import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { CreditCard, Save } from 'lucide-react';

// A6: çevrimiçi ödeme yok. Ana yönetici (sahip kilidi) tek alanı girer: mekânın "Premium ol" düğmesinin açtığı
// bağlantı. Sunucu doğrular (https, kimlik bilgisi ve port yok, geçerli alan adı, ≤500); bağlantı ürün sahibinin
// kendi bilet sitesinde olabilir (bu alana özel istisna).
const API = process.env.REACT_APP_BACKEND_URL;
const ENDPOINT = `${API}/api/admin/settings/membership-payment`;
const detailOf = err => err?.response?.data?.detail;

export default function MembershipPaymentSettings() {
  const [state, setState] = useState({ loading: true, allowed: false, error: '' });
  const [url, setUrl] = useState('');
  const [saved, setSaved] = useState({ payment_url: '', updated_at: null });
  const [saving, setSaving] = useState(false), [fieldError, setFieldError] = useState({});

  const load = useCallback(async () => {
    setState(s => ({ ...s, loading: true, error: '' }));
    try {
      const { data } = await axios.get(ENDPOINT);
      setSaved(data); setUrl(data.payment_url || '');
      setState({ loading: false, allowed: true, error: '' });
    } catch (err) {
      setState({ loading: false, allowed: false, error: err?.response?.status === 403 ? '' : 'Ödeme ayarı alınamadı.' });
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const save = async event => {
    event.preventDefault(); setSaving(true); setFieldError({});
    try {
      const { data } = await axios.put(ENDPOINT, { payment_url: url.trim() });
      setSaved(data); setUrl(data.payment_url || '');
      toast.success(data.changed?.length ? 'Ödeme bağlantısı kaydedildi' : 'Değişiklik yok');
    } catch (err) {
      const detail = detailOf(err);
      if (detail?.field) setFieldError({ [detail.field]: detail.message });
      else toast.error(typeof detail === 'string' ? detail : 'Ödeme bağlantısı kaydedilemedi');
    } finally { setSaving(false); }
  };

  return <section className="bg-white border border-zinc-100 rounded-2xl p-6 space-y-4 admin-responsive-card" data-testid="membership-payment-settings">
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 rounded-xl bg-[#E6EEFF] flex items-center justify-center"><CreditCard size={18} strokeWidth={1.75} className="text-[#1E3A8A]" /></div>
      <div>
        <h2 className="text-base font-semibold text-zinc-900">Ücretli mekân ödeme bilgisi</h2>
        <p className="text-xs text-zinc-500">{"Mekânlar 'Premium ol' düğmesine tıklayınca bu bağlantıya gider."}</p>
      </div>
    </div>
    {state.loading ? <p role="status" className="text-sm text-zinc-500">Yükleniyor…</p>
      : !state.allowed ? <p className="text-sm text-zinc-600" data-testid="membership-payment-locked">{state.error || 'Ödeme bağlantısını yalnız ana yönetici görüntüleyebilir ve değiştirebilir.'}</p>
        : <form onSubmit={save} className="space-y-3">
          <label className="block text-xs font-medium text-zinc-600" htmlFor="membership-payment-url">Premium ol bağlantısı (https)</label>
          <input id="membership-payment-url" data-testid="membership-payment-url" type="url" inputMode="url" maxLength={500} autoComplete="off" spellCheck={false}
            value={url} onChange={e => setUrl(e.target.value)} placeholder="https://…" aria-invalid={!!fieldError.payment_url}
            aria-describedby={fieldError.payment_url ? 'membership-payment-url-error' : undefined}
            className="w-full h-11 rounded-xl border border-zinc-200 bg-zinc-50 px-3.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1E3A8A]/30" />
          {fieldError.payment_url && <p id="membership-payment-url-error" role="alert" className="text-xs text-red-700" data-testid="membership-payment-url-error">{fieldError.payment_url}</p>}
          <div className="flex flex-wrap items-center gap-3">
            <button type="submit" disabled={saving} data-testid="membership-payment-save" className="inline-flex items-center gap-2 h-10 px-4 rounded-xl bg-[#1E3A8A] text-white text-sm font-medium disabled:opacity-50"><Save size={15} />{saving ? 'Kaydediliyor…' : 'Kaydet'}</button>
            {saved.updated_at && <span className="text-xs text-zinc-500">Son güncelleme: {new Date(saved.updated_at).toLocaleString('tr-TR')}</span>}
          </div>
        </form>}
  </section>;
}
